import React from 'react';
import { Users, TrendingUp, Award, MapPin } from 'lucide-react';
import StatCard from '../../../components/ui/StatCard';

const PeopleIllustration = () => <Users className="w-10 h-10" />;
const TrendIllustration = () => <TrendingUp className="w-10 h-10" />;
const BadgeIllustration = () => <Award className="w-10 h-10" />;
const LocationIllustration = () => <MapPin className="w-10 h-10" />;

export const TeamStats = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 w-full">
      <StatCard
        variant="luxury"
        title="Active Members"
        value={stats?.activeCount || '0'}
        sub="Currently active team"
        illustration={<PeopleIllustration />}
        topColor="border-t-[#5d6b8b]"
        iconHoverColor="group-hover:text-[#ffa000]"
      />
      <StatCard
        variant="luxury"
        title="Active Rate"
        value={stats?.activePercentage ? `${Math.round(stats.activePercentage)}%` : '0%'}
        sub="Team activity percentage"
        illustration={<TrendIllustration />}
        topColor="border-t-[#5d6b8b]"
        iconHoverColor="group-hover:text-[#ffa000]"
      />
      <StatCard
        variant="luxury"
        title="Role Types"
        value={`${stats?.roleCount || '0'}`}
        sub="Unique roles in team"
        illustration={<BadgeIllustration />}
        topColor="border-t-[#5d6b8b]"
        iconHoverColor="group-hover:text-[#ffa000]"
      />
      <StatCard
        variant="luxury"
        title="Locations"
        value={`${stats?.locationCount || '0'}`}
        sub="Work locations covered"
        illustration={<LocationIllustration />}
        topColor="border-t-[#5d6b8b]"
        iconHoverColor="group-hover:text-[#ffa000]"
      />
    </div>
  );
};
